// Runtime compatibility for saved plugins while the database migration rolls out.
export const RETIRED_HAIKU_ENGINES = Object.freeze({
  "claude-3-haiku-20240307": "claude-haiku-5-5",
  "claude-3-5-haiku-20241022": "claude-haiku-5-5",
});

export const resolveRetiredHaikuEngine = (engine) => Object.hasOwn(RETIRED_HAIKU_ENGINES, engine) ? RETIRED_HAIKU_ENGINES[engine] : engine;
